<template>
  <address-form title="ویرایش آدرس" :submit-function="updateAddress"/>
</template>

<script>
import AddressForm from '../Address/AddressForm';
import {mapActions} from 'vuex';

export default {
  name: "UpdateAddress",
  components: {AddressForm},
  methods: {
    updateAddress(form) {

      if (this.$route.query.mode === 'default-address') {
        form.default_address = 1;
      }

      this.$store.dispatch('Address/updateAddress', form);

    }
  }
};
</script>

<style scoped>
</style>